module.exports = __webpack_public_path__ + "img/section2Bg3M.140e3c4d.webp";